// import { lottoTranslateToCategory } from '@/utils/dataProcessing.js'
export default (key, gameCategory) => {
  // 因為後端API 會直接提供 category, 現在不使用 dataProcessing.js
  // const gameCategory = lottoTranslateToCategory(lotto)
  const keyObj = require(`./game/${gameCategory}.js`).default

  return keyObj[key]
}
